import React, { useMemo } from "react";
import { format } from "date-fns";
import { Alert, Text } from "@networkraildigitalfactory/components";

import SliderSelect from "../SliderSelect/SliderSelect";
import OneToOneInfo from "./OneToOneInfo";
import { useObjectives, usePDP } from "../../hooks/useAPI";
import useUser from "../../hooks/useUser";

const ViewOneToOneData = (props) => {
  const {
    createdAt,
    prep: {
      additionalComments,
      challengesDesc,
      discussObjective,
      discussDevelopmentGoal,
      successDesc,
      wellBeingFeeling,
      objectivesDesc,
      objectives,
      developmentGoalsDesc,
      developmentGoals,
      isPrepCompleted,
    },
    currentFeedback,
  } = props.data;
  const { isGBR } = useUser();

  const questionsContent = {
    gbr: {
      success: "What would you like to celebrate?",
      challenge: "What have you found challenging? What do you need to help you progress?",
    },
    nr: {
      success: "What are some of your biggest successes since your last 1-2-1?",
      challenge: "What have you found challenging?",
    },
  };

  const questions = useMemo(() => {
    return isGBR ? questionsContent.gbr : questionsContent.nr;
  }, [isGBR]);

  const [{ data: allObjectives }] = useObjectives();
  let selectedObjectives = allObjectives && allObjectives.filter((i) => objectives.includes(i._id));

  const [{ data: allDevelopmentGoals }] = usePDP();
  let selectedDevelopmentGoals =
    allDevelopmentGoals && allDevelopmentGoals.filter((i) => developmentGoals.includes(i._id));

  let objectiveListView = true;
  if (selectedObjectives && selectedObjectives.length === 1) {
    objectiveListView = false;
    selectedObjectives = selectedObjectives[0].name;
  }
  let developmentGoalListView = true;
  if (selectedDevelopmentGoals && selectedDevelopmentGoals.length === 1) {
    developmentGoalListView = false;
    selectedDevelopmentGoals = selectedDevelopmentGoals[0].name;
  }

  return (
    <>
      {currentFeedback && <Alert title="Line manager's feedback" message={currentFeedback} />}
      {isPrepCompleted && (
        <>
          <OneToOneInfo
            label="Date created"
            answer={format(new Date(createdAt), "dd/MM/yyyy")}
            wrapper="span"
          />
          <OneToOneInfo label={questions.success} answer={successDesc} />
          <OneToOneInfo label={questions.challenge} answer={challengesDesc} />
          <OneToOneInfo
            label="Is there any particular objective(s) you would like to discuss at this 1-2-1?"
            answer={discussObjective ? selectedObjectives : "No thanks"}
            wrapper="span"
            isList={(discussObjective && objectiveListView) || false}
          />
          {discussObjective && (
            <OneToOneInfo
              label="Please give an overview of what you would like to discuss"
              answer={objectivesDesc}
            />
          )}
          <OneToOneInfo
            label="Is there any particular development goal(s) you would like to discuss at this 1-2-1?"
            answer={discussDevelopmentGoal ? selectedDevelopmentGoals : "No thanks"}
            wrapper="span"
            isList={(discussDevelopmentGoal && developmentGoalListView) || false}
          />
          {discussDevelopmentGoal && (
            <OneToOneInfo
              label="Please give an overview of what you would like to discuss"
              answer={developmentGoalsDesc}
            />
          )}
          <Text
            wrapper="h3"
            type="subtitle"
            style={{
              fontSize: "20px",
              lineHeight: "140%",
              letterSpacing: "0.0015em",
              marginTop: "14px",
            }}
          >
            Wellbeing check-in
          </Text>
          {wellBeingFeeling === 0 ? (
            <div>
              <OneToOneInfo
                label="Please mark how you are feeling on the below scale:"
                answer="N/A"
              />
            </div>
          ) : (
            <div>
              <OneToOneInfo label="Please mark how you are feeling on the below scale:" />
              <SliderSelect value={wellBeingFeeling} />
            </div>
          )}
          <OneToOneInfo label="Any additional comments?" answer={additionalComments} />
        </>
      )}
    </>
  );
};

export default ViewOneToOneData;
